import { Injectable } from '@angular/core';
import { ProviderSite, ProviderSiteDto } from '../../models/provider-parking/provider-site.model';

@Injectable({
    providedIn: 'root',
})
export class MapperProviderSiteService {
    
    constructor() { }

    /** 
     * Map Data From API (DTO) to Logical Model (ProviderSite) 
     */
    public mapProviderSiteFromDto(dto: ProviderSiteDto): ProviderSite {
        return {
            id: dto.Id || 0,
            name: dto.SiteName || '',
            lot: dto.MaxLots || 0,
            providerName: dto.ProviderName || '',
            vehicleType: dto.VehicleType || '',
            isOnline: dto.StatusOnline || false,
            site: dto.ProjectCode || ''
        };
    }

    /** 
     * Map Logical Model (ProviderSite) back to API (DTO) 
     */
    public mapProviderSiteToDto(model: ProviderSite): ProviderSiteDto {
        return {
            Id: model.id,
            SiteName: model.name,
            MaxLots: model.lot,
            ProviderName: model.providerName,
            VehicleType: model.vehicleType,
            StatusOnline: model.isOnline,
            ProjectCode: model.site
        };
    }
}
